export const legacyFeatureKeys = ['dayResources', 'sessionResults', 'sessionExitSurvey', 'equipmentDayOverride', 'equipmentArtwork'] as const
export const redesignKeys = ['profileRedesign', 'playerRedesign'] as const
export const onboardingKeys = ['webOnboarding', 'appStoreOnboarding'] as const
export const rc50PromptKeys = ['notificationConsent', 'trustpilotReview'] as const
export const featureKeys = [...legacyFeatureKeys, ...redesignKeys, ...onboardingKeys, ...rc50PromptKeys] as const
export type FeatureKey = typeof featureKeys[number]
export type Platform = 'ios' | 'android'
export interface FeatureRule {
  enabled: boolean
  platforms: Partial<Record<Platform, { minVersion: string; minBuildNumber: number }>>
  rolloutBasisPoints: number
  cohortVersion: string
  internalUserIds: string[]
  minCompletedSessions?: number
}
export interface FeatureSettings {
  configRevision: string
  rules: Record<typeof legacyFeatureKeys[number], FeatureRule> & Partial<Record<typeof redesignKeys[number] | typeof onboardingKeys[number] | typeof rc50PromptKeys[number], FeatureRule>>
}

export function supportsFeature(settings: FeatureSettings, key: FeatureKey): boolean {
  return Object.prototype.hasOwnProperty.call(settings.rules, key)
}

export function featureUpdate(settings: FeatureSettings, reason: string) {
  const keys = rc50PromptKeys.some(key => supportsFeature(settings, key)) ? featureKeys
    : onboardingKeys.some(key => supportsFeature(settings, key)) ? [...legacyFeatureKeys, ...redesignKeys, ...onboardingKeys]
    : redesignKeys.some(key => supportsFeature(settings, key)) ? [...legacyFeatureKeys, ...redesignKeys] : legacyFeatureKeys
  if (Object.keys(settings.rules).length !== keys.length || keys.some(key => !supportsFeature(settings, key))) {
    throw new Error('Unsupported feature settings. Reload before saving.')
  }
  // Send only capabilities returned by the server. An older backend accepts
  // five, seven or nine rules; never synthesize capabilities in that payload.
  return { expectedRevision: settings.configRevision, rules: settings.rules, reason }
}
